import { NgStyle } from '@angular/common';
import { NgModule } from '@angular/core';

import { OnboardingBackgroundFlairComponent } from '@main-client/src/app/onboarding-background-flair/onboarding-background-flair.component';

@NgModule({
  declarations: [OnboardingBackgroundFlairComponent],
  exports: [OnboardingBackgroundFlairComponent],
  imports: [NgStyle],
})
export class OnboardingBackgroundFlairModule {}
